// VT220 Terminal Effects

const TERMINAL = {
  DEFAULT_TYPE_SPEED: 30,   // ms per character
  DEFAULT_TYPE_DELAY: 500,  // ms x element index for stagger
  BOOT_TYPE_SPEED: 15,      // ms per character during boot
  FLICKER_CHANCE: 0.02,     // probability per interval tick
  FLICKER_INTERVAL: 2000,   // ms between flicker checks
  FLASH_DURATION: 150,      // ms before flash overlay removed
  BOOT_LINE_PAUSE: 200,     // ms between boot lines
};

function initTerminal() {
  // Generate session ID
  const sessionEl = document.getElementById('session-id');
  if (sessionEl && !sessionEl.dataset.terminalProcessed) {
    const hex = Array.from(crypto.getRandomValues(new Uint8Array(4)))
      .map(b => b.toString(16).padStart(2, '0'))
      .join('').toUpperCase();
    sessionEl.textContent = 'SESSION: ' + hex;
    sessionEl.dataset.terminalProcessed = 'true';
  }

  // Typing animation for elements with data-terminal-type attribute
  const typeElements = document.querySelectorAll('[data-terminal-type]');

  typeElements.forEach((element, index) => {
    // Skip if already processed
    if (element.dataset.terminalProcessed) return;

    // Store original text before we modify anything
    const text = element.dataset.terminalText || element.textContent.trim();
    element.dataset.terminalText = text;
    element.dataset.terminalProcessed = 'true';

    const speed = parseInt(element.dataset.typeSpeed) || TERMINAL.DEFAULT_TYPE_SPEED;
    const delay = parseInt(element.dataset.typeDelay) || (index * TERMINAL.DEFAULT_TYPE_DELAY);
    const hasCursor = element.hasAttribute('data-terminal-cursor');

    element.textContent = '';
    element.style.visibility = 'visible';

    setTimeout(() => {
      typeText(element, text, speed, hasCursor);
    }, delay);
  });

  // Terminal link click effect
  document.querySelectorAll('a').forEach(link => {
    if (link.dataset.terminalProcessed) return;
    link.dataset.terminalProcessed = 'true';

    link.addEventListener('click', (e) => {
      if (!e.ctrlKey && !e.metaKey) {
        screenFlash('navigate');
      }
    });
  });

  // Random subtle screen flicker (only set up once)
  if (!window.terminalFlickerInitialized) {
    window.terminalFlickerInitialized = true;
    setInterval(() => {
      if (Math.random() < TERMINAL.FLICKER_CHANCE) {
        screenFlicker();
      }
    }, TERMINAL.FLICKER_INTERVAL);
  }

  // Boot sequence if present
  const bootSequence = document.querySelector('[data-terminal-boot]');
  if (bootSequence && !sessionStorage.getItem('terminalBooted')) {
    sessionStorage.setItem('terminalBooted', 'true');
    bootSequence.dataset.terminalProcessed = 'true';
    runBootSequence(bootSequence);
  } else if (bootSequence && !bootSequence.dataset.terminalProcessed) {
    // Show final boot state without animation on subsequent Turbo navigations
    bootSequence.dataset.terminalProcessed = 'true';
    const lines = bootSequence.dataset.terminalBoot.split('|');
    bootSequence.style.visibility = 'visible';
    lines.forEach(l => {
      const div = document.createElement('div');
      div.className = 'boot-line';
      div.textContent = l;
      bootSequence.appendChild(div);
    });
  }
}

function typeText(element, text, speed, addCursorWhenDone = false) {
  let i = 0;
  element.textContent = '';

  const type = () => {
    if (i < text.length) {
      element.textContent += text.charAt(i);
      i++;
      setTimeout(type, speed + Math.random() * 20);
    } else {
      if (addCursorWhenDone) {
        const cursor = document.createElement('span');
        cursor.className = 'terminal-cursor';
        cursor.textContent = '_';
        element.appendChild(cursor);
      }
      element.dispatchEvent(new CustomEvent('typeComplete'));
    }
  };
  type();
}

function screenFlash(type = 'navigate') {
  const flash = document.createElement('div');
  flash.className = `screen-flash screen-flash-${type}`;
  document.body.appendChild(flash);
  setTimeout(() => flash.remove(), TERMINAL.FLASH_DURATION);
}

function screenFlicker() {
  document.body.classList.add('screen-flicker');
  setTimeout(() => {
    document.body.classList.remove('screen-flicker');
  }, 50 + Math.random() * 100);
}

function runBootSequence(container) {
  const lines = container.dataset.terminalBoot.split('|');
  container.replaceChildren();
  container.style.visibility = 'visible';

  let lineIndex = 0;

  const addLine = () => {
    if (lineIndex < lines.length) {
      const line = document.createElement('div');
      line.className = 'boot-line';
      container.appendChild(line);

      typeText(line, lines[lineIndex], TERMINAL.BOOT_TYPE_SPEED, false);
      line.addEventListener('typeComplete', () => {
        lineIndex++;
        setTimeout(addLine, TERMINAL.BOOT_LINE_PAUSE);
      });
    }
  };

  addLine();
}

document.addEventListener('DOMContentLoaded', initTerminal);
document.addEventListener('turbo:load', initTerminal);
